import { render, staticRenderFns } from "./register-references.vue?vue&type=template&id=29b81d59&"
import script from "./register-references.vue?vue&type=script&lang=js&"
export * from "./register-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports